// src/modules/estimates/estimateService.js
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || ''; // Use the API URL from the .env file
// Get the auth token from localStorage or authService
// Function to get the token from local storage
const getAuthToken = () => {
  const token = localStorage.getItem('token');
  if (!token) {
    console.error('No token found. Please login again.');
  }
  return token;
};

// Set the Authorization header with the token
const getHeaders = () => {
  const token = getAuthToken();
  if (!token) {
    return {}; // Return an empty object if there's no token
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
};

// Fetch all predefined estimate details
export const getEstimateDetails = async () => {
  try {
    const response = await axios.get(`${API_URL}/estimate`, getHeaders());
    return response;
  } catch (error) {
    console.error('Error fetching estimate details:', error);
    throw error;
  }
};

// Fetch estimates filtered by a single status (e.g. 'Accepted')
// Returns an array of estimates including items[].Service.service_name and leadId.
export const getEstimatesByStatus = async (status) => {
  try {
    const response = await axios.get(`${API_URL}/estimate/by-status`, {
      params: { status },
      ...getHeaders(),
    });
    return response;
  } catch (error) {
    console.error('Error fetching estimates by status:', error);
    throw error;
  }
};

// Fetch all available services
export const getServices = async () => {
  try {
    const response = await axios.get(`${API_URL}/services`, getHeaders());
    return response;
  } catch (error) {
    console.error('Error fetching services:', error);
    throw error;
  }
};

// Create a new estimate
export const createEstimate = async (data) => {
  try {
    const response = await axios.post(`${API_URL}/estimate`, data, getHeaders());
    return response;
  } catch (error) {
    console.error('Error creating estimate:', error);
    throw error;
  }
};

// Update an existing estimate
export const updateEstimate = async (id, data) => {
  try {
    console.log(data);
    const response = await axios.put(`${API_URL}/estimate/${id}`, data, getHeaders());
    console.log("Response: ", response);
    return response;
  } catch (error) {
    console.error('Error updating estimate:', error);
    throw error;
  }
};

export const updateEstimateStatus = async(id, data) => {
  try{
    console.log(id, data);
    
    const response = await axios.put(`${API_URL}/estimate/${id}/status`, data, getHeaders());
    console.log("Response Status Update: ",response);
    return response;
  }catch(error){
    console.error("Eerror updating Estimate Status: ", error);
  }
}

export const updateEstimateStatusOnly = async(id, data) => {
  try{
    const response = await axios.put(`${API_URL}/estimate/${id}/status-only`, data, getHeaders());
    return response;
  }catch(error){
    console.error("Error updating Estimate Status (status-only): ", error);
    throw error;
  }
}

// Fetch estimate by ID
export const getEstimateById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/estimate/${id}`, getHeaders());
    return response;
  } catch (error) {
    console.error('Error fetching estimate:', error);
    throw error;
  }
};

// Fetch suppliers based on job site location and radius
export const getSuppliersByLocation = async (latitude, longitude, radius = 20) => {
  try {
    const headers = getHeaders();
    if (!headers.headers.Authorization) {
      throw new Error('Missing or invalid authentication token. Please login again.');
    }

    // Make sure API_URL is defined and correct
    if (!API_URL) {
      throw new Error('API_URL is not defined. Check your .env file and ensure the correct API URL is set.');
    }

    const response = await axios.get(`${API_URL}/suppliers`, {
      params: { lat: latitude, lng: longitude, radius },
      ...headers,
    });

    return response;
  } catch (error) {
    console.error('Error fetching suppliers:', error);
    throw error;
  }
};

export const deleteEstimate = async (id) => {
  try{
    const response = await axios.delete(`${API_URL}/estimate/${id}`, getHeaders());
    return response;
  }catch (error) {
    console.error('Error deleting estimate: ', error);
    throw error;
  }
};

// Estimate Image APIs
export const uploadEstimateImage = async (estimateId, file, displaySize = 'full') => {
  const formData = new FormData();
  formData.append('image', file);
  formData.append('displaySize', displaySize);
  const token = getAuthToken();
  const response = await axios.post(`${API_URL}/estimate/${estimateId}/images`, formData, {
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'multipart/form-data',
    },
  });
  return response;
};

export const getEstimateImages = async (estimateId) => {
  const response = await axios.get(`${API_URL}/estimate/${estimateId}/images`, getHeaders());
  return response;
};

export const updateEstimateImage = async (estimateId, imageId, data) => {
  const response = await axios.put(`${API_URL}/estimate/${estimateId}/images/${imageId}`, data, getHeaders());
  return response;
};

export const deleteEstimateImage = async (estimateId, imageId) => {
  const response = await axios.delete(`${API_URL}/estimate/${estimateId}/images/${imageId}`, getHeaders());
  return response;
};